import { UseQueryResult } from '@tanstack/react-query'
import React from 'react'

import { THEME_PALETTE, Z_INDEX } from '../../../../constants/constants'
import { GlobalSearchResultsItem } from '../../../../types/responses/global-search'
import { useGlobalSearch } from '../hooks/useGlobalSearch'
import SearchInput from './SearchBox/components/SearchInput'
import SearchBox from './SearchBox/SearchBox'

interface Props {
  globalSearchQuery: UseQueryResult<GlobalSearchResultsItem>
}

const DesktopSearchBox: React.FC<Props> = ({ globalSearchQuery }) => {
  const globalSearch = useGlobalSearch()

  return (
    <>
      <SearchInput isLoading={globalSearchQuery.isFetching} />

      {globalSearch.isShowing && globalSearch.searchTerm.length > 0 && (
        <section
          className="bg-white w-100 position-absolute overflow-auto start-0 end-0 p-3"
          style={{
            zIndex: Z_INDEX.globalSearch,
            borderRadius: '4px',
            border: `1px solid ${THEME_PALETTE.borderColor}`,
            maxHeight: '65vh',
            top: '40px',
          }}
        >
          <SearchBox globalSearchQuery={globalSearchQuery} />
        </section>
      )}
    </>
  )
}

export default DesktopSearchBox
